import { useEffectOnce } from 'hook/useEffectOnce'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import css from './WidgetBlur.module.scss'

export const WidgetBlur = observer(() => {
  const [show, setShow] = useState(false)

  useEffectOnce(() => {
    const id = setInterval(() => {
      const max = !!document.querySelector('.showoff-widget-max')
      setShow(max)
    }, 100)

    return () => clearInterval(id)
  })

  if (!show) return null

  return <div className={css.blur} />
})
